import { Component, OnInit } from '@angular/core';
import {AngularFireAuth} from "@angular/fire/auth";
import {Router} from "@angular/router";

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.css']
})
export class LoginComponent implements OnInit {
    private user: string = "test@test.com";
    private pswd: string = "covidtest";

  constructor(
      private afs:AngularFireAuth,
      private router:Router,
  ) { }

  ngOnInit() {

  }
    email() {
        this.afs.auth.signInWithEmailAndPassword(
        this.user,this.pswd)
            .then((success)=>{
            this.router.navigate(['/']);

               //
                // ("iddiiid" + success.user.uid);
            }).then().catch(er =>{
           // this.router.navigate(['/']);

            alert(er)
            }

        )}
}
